import { toast } from 'sonner';
import type { TranscribeOutcome } from './useVoiceInput';

/**
 * Says what happened to a dictation.
 *
 * Getting the clip back is deliberately NOT here. It was, as an action on this
 * toast, and a toast is mounted at the app root — so the affordance outlived
 * the screen that recorded the audio and could drop one truck's words into
 * another truck's composer. `VoiceRetryChip` lives inside the composer instead,
 * where it cannot. This just tells the tech, in words they can act on, that
 * their recording is still there.
 */
export function reportTranscribe(outcome: TranscribeOutcome): void {
  if (outcome.text || !outcome.message) return;
  if (outcome.canRetry) toast.error(outcome.message);
  else toast.message(outcome.message);
}
